/**
 * Handles long text features - mainly ellipsis
 * User: itziky
 * Date: 1/29/14
 */
define(function (require) {
    "use strict";

    var Modernizr = require('modernizr');
    var _ = require("underscore");
    var $ = require("jquery");
    require('ui.plugins/jquery.ellipsis');

    // Silent handling of multiline ellipsis - by listening to any show event and checking relevant class names (ellipsis-2, ellipsis-3...)
    var handleEllipsis = function(isHoverEvent) {
        var KEYWORD = "ellipsis",
            ELLIPSIS = "...";

        this.$el.find("[class*='" + KEYWORD + "']").each(function() {
            // Do Nothing if the item is not in the DOM yet
            if (0 === this.clientWidth) {
                return;
            }
            var classes = $(this).attr("class").split(/\s+/);
            $.each(classes, _.bind(function(i, item){
                var numRows,
                    strNum,
                    fullText = $(this).text(),

                    /**
                     * A (not trivial) way to detect if text is trimmed and we have the appropriate full text in data attribute
                     */
                        havingTheFullText = function($el) {
                        var savedFullText = $el.data("fullText"),
                            trimmedText;

                        if (savedFullText && $el.text().lastIndexOf(ELLIPSIS) === $el.text().length - ELLIPSIS.length) {
                            trimmedText = $el.text().substring(0, $el.text().length - ELLIPSIS.length);
                            if (savedFullText.indexOf(trimmedText) === 0) {
                                return true;
                            }
                        }
                        return false;
                    },

                    setTooltip= function(el) {
                        if (!isHoverEvent && fullText) {
                            $(el).attr("title", fullText);
                        }
                    };

                if (item === KEYWORD) {
                    // Single line ellipsis - just need to handle tooltip
                    if (this.scrollWidth > this.clientWidth) {
                        setTooltip(this);
                    }
                } else if (item.indexOf(KEYWORD) === 0) {
                    strNum = item.substring(KEYWORD.length+1);

                    if (!isNaN(strNum)) {
                        // Multi line ellipsis - do JS ellipsis (if no browser support for line clamp) and handle tooltip
                        if (Modernizr.lineclamp) {
                            if (this.scrollHeight > this.clientHeight+2) {  // TODO check if simply this.offsetHeight is better
                                setTooltip(this);
                            }
                        } else {
                            numRows = parseInt(strNum, 10);
                            if (isHoverEvent && $(this).data("fullText")) {
                                // for hover events - restore the original full text to generate an appropriate ellipsis text
                                $(this).text($(this).data("fullText"));
                            }

                            // A fallback when browser doesn't know to break a single long word - if it had a narrower parent
                            var $parent = $(this).parent();
                            while ($parent.length > 0 && ($parent[0].clientWidth <= this.scrollWidth)) {
                                if ($parent[0].clientWidth < this.scrollWidth) {
                                    $(this).css("word-break", "break-all");
                                    break;
                                }
                                $parent = $parent.parent();
                            }

                            // Before potential trimming - detect ful text is already kept
                            if (havingTheFullText($(this))) {
                                fullText = undefined;
                            }

                            $(this).ellipsis({
                                row: numRows,
                                char: ELLIPSIS,
                                callback: function(isTrimmed) {
                                    if (isTrimmed) {
                                        setTooltip(this);
                                        if (fullText) {
                                            $(this).data("fullText", fullText);
                                        }
                                    }
                                }});
                        }
                    }
                }
            }, this));
        });
    };

    var handle = function(view) {
        // listen to relevant events when handle ellipsis should be done implicitly (on show and on render)
        view.on("show render", _.bind(function() {
            //the defer fixes the LE-25997 bug where tooltip is not displayed when ellipsis is applied
            _.defer(_.bind(function(){
                handleEllipsis.call(this, false);
            }, this));
        }, view));

        // stop listening
        view.once("close", _.bind(function(){
            this.off("show render", handleEllipsis);
        }, view));
    };

    var handleNow = function(view) {
        handleEllipsis.call(view, false);
    };

    var handleHover = function(view) {
        handleEllipsis.call(view, true);
    };

    /**
     * For special cases when hover changes the available width of the element (for example, when the Edit link appears for gallery item on hover)
     * Browser (IE) might not know to break a single long word - we need to force width on hover
     */
    var adjustWidth = function($el, maxWidth, isSetWidth) {
        var width = (isSetWidth && !_.isUndefined(maxWidth) && $el[0].clientWidth > maxWidth) ? maxWidth : '';
        $el.css("width", width);
    };

    return {
        handle: handle,
        handleNow: handleNow,
        handleHover: handleHover,
        adjustWidth: adjustWidth
    };
});
